export default "__VITE_PUBLIC_ASSET__af8f6e4c__"